<template>
  <div
    class="c-categoryTypeListForSeo"
    v-if="isCategoryTypes"
  >
    <h2 class="c-categoryTypeListForSeo_title">
      <strong>{{ this.categoryName }}の関連カテゴリ一覧</strong>
    </h2>
    <template v-for="(item, index) in categoryTypes">
      <div
        class="c-categoryTypeListForSeo_list"
        :key="item.id"
        v-if="currentCategoryTypeId !== item.id"
      >
        <nuxt-link :to="`/categories/${childCategoryId}/${item.id}`">{{ item.name }}</nuxt-link>
        <span v-if="index + 1 < categoryTypes.length">｜</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'categoryTypeListForSeo',
  props: {
    childCategoryId: {
      type: Number,
      default: null
    },
    categoryName: {
      type: String,
      default: null
    },
    currentCategoryTypeId: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapState('master', ['masterCategoryTypesList']),
    categoryTypes() {
      return this.masterCategoryTypesList.find(i => i.masterCategoryId === this.childCategoryId)
        ?.masterCategoryTypesList
    },
    isCategoryTypes() {
      return this.categoryTypes?.length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.c-categoryTypeListForSeo {
  &_title {
    margin-bottom: 8px;

    strong {
      color: $color-gray-900;
      font-size: 20px;
    }
  }
  &_list {
    display: inline-block;
    font-size: 12px;

    a {
      @include link-effect;

      color: $color-gray-800;
    }
  }
}
</style>
